import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LogoutCallbackResolver implements Resolve<void> {
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        console.log('LogoutCallback route accessed');
    }
}